import moment from "moment-timezone";
import { Calendar } from "primereact/calendar";
import React from "react";

type Props = {
	name: string;
	value: string | undefined;
	onUpdate: (newValue: string | undefined) => void;
	disabled: boolean;
	footerTemplate?: () => React.ReactNode;
	inline?: boolean | undefined;
};

export function ConfigDatePicker({
	name,
	value,
	onUpdate,
	disabled,
	footerTemplate,
	inline,
}: Props) {
	return (
		<Calendar
			name={name}
			showTime
			visible={true}
			hourFormat="24"
			dateFormat={"dd.mm.yy"}
			disabled={disabled}
			inline={inline}
			footerTemplate={footerTemplate}
			value={value ? moment(value.replace("[UTC]", "")).toDate() : undefined}
			onChange={(e) =>
				onUpdate(e.value ? moment(e.value as Date).format("YYYY-MM-DDTHH:mmZ") : undefined)
			}
		/>
	);
}
